import { BaseService } from "@/core/services/BaseService";
import { INote } from "@/core/entity/INote";
import { ENDPOINT } from "@/core/config/Constant";

class NoteService extends BaseService<INote> {
  endpoint = ENDPOINT.NOTE;
}
export default new NoteService();